import {
  type ComponentsState,
  type ErrorComponentsState,
  Piral,
  type PiralInstance,
  SetErrors,
  SetLayout,
  SetRoute
} from 'piral-core'
import type * as React from 'react'
import { Dashboard } from './Dashboard'

export function createInstanceElementWithoutBreakpoints(
  instance?: PiralInstance,
  layout?: Partial<ComponentsState>,
  errors?: Partial<ErrorComponentsState>,
  dashboardPath = '/',
  piralChildren?: React.ReactNode
): React.ReactElement {
  return (
    <Piral instance={instance} breakpoints={[]}>
      <SetLayout layout={layout} />
      <SetErrors errors={errors} />
      <SetRoute path={dashboardPath} component={Dashboard} />
      {piralChildren}
    </Piral>
  )
}
